import { render, staticRenderFns } from "./worldmap.vue?vue&type=template&id=7127f12e&"
import script from "./worldmap.vue?vue&type=script&lang=js&"
export * from "./worldmap.vue?vue&type=script&lang=js&"
import style0 from "./worldmap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports